// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReceiptsPage.module.css */

/* === Общий контейнер === */
.ReceiptsPage_tableWrapper__ftYE- {
  overflow-x: auto;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  padding-right: 6px;
}

/* === Таблица === */
.ReceiptsPage_table__TJ\\+eX {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  font-size: 13px;
}

.ReceiptsPage_table__TJ\\+eX th {
  background: #f5f6fa;
  text-align: left;
  padding: 8px 10px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}

.ReceiptsPage_table__TJ\\+eX td {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
  color: #444;
}

.ReceiptsPage_table__TJ\\+eX tr:hover {
  background: #fafafa;
}

.ReceiptsPage_right__Fw4YC {
  text-align: right;
}

/* === Блок товаров (единый стиль) === */
.ReceiptsPage_productsBlock__jA0N5 {
  margin-top: 6px;
  padding-top: 4px;
  border-top: 1px dashed #e0e0e0;
  font-size: 12px;
  color: #555;
}

.ReceiptsPage_productItem__IUd\\+A {
  display: flex;
  gap: 8px;
  align-items: baseline;
  justify-content: space-between;
  margin: 2px 0;
}

.ReceiptsPage_productName__qN8WM {
  flex: 1 1 auto;
  font-weight: 500;
}

.ReceiptsPage_productQty__P2xCp {
  flex: 0 0 auto;
  min-width: 60px;
  text-align: right;
}

.ReceiptsPage_productPrice__drr72 {
  flex: 0 0 auto;
  min-width: 80px;
  text-align: right;
  opacity: 0.8;
}

.ReceiptsPage_productSum__wg6An {
  flex: 0 0 auto;
  min-width: 90px;
  text-align: right;
  font-weight: 600;
}

/* === Карточки === */
.ReceiptsPage_cardsWrapper__aB-i4 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 12px;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  padding-right: 6px;
}

.ReceiptsPage_receiptCard__4Eu55 {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: all 0.2s ease;
}

.ReceiptsPage_receiptCard__4Eu55:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}

.ReceiptsPage_receiptHeader__nRkNn {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

.ReceiptsPage_receiptNumber__2ZG-J {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #3f51b5;
}

.ReceiptsPage_receiptDate__1YtrN {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #757575;
  font-weight: 500;
}

.ReceiptsPage_receiptBody__j9YHO {
  font-size: 13px;
  color: #444;
  line-height: 1.4;
  margin-top: 4px;
}

.ReceiptsPage_receiptBody__j9YHO p {
  margin: 2px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ReceiptsPage_comment__3Jt4M {
  margin-top: 4px;
  padding: 4px 6px;
  background: #fff8e1;
  border-radius: 4px;
  font-size: 12px;
}

/* === Переключатели вида === */
.ReceiptsPage_viewSwitch__90GtE {
  display: flex;
  gap: 6px;
  margin-left: 10px;
}

.ReceiptsPage_switchBtn__w1WNf {
  background: #f9fafc;
  border: 1px solid #cbd3e1;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ReceiptsPage_switchBtn__w1WNf:hover {
  background: #e8eaf6;
}

.ReceiptsPage_switchBtn__w1WNf.ReceiptsPage_active__2VMBD {
  background: #3f51b5;
  color: #fff;
  border-color: #3f51b5;
}

/* === Панель с переключателем и районом === */
.ReceiptsPage_filtersRow__nANre {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 10px;
}

.ReceiptsPage_districtFilter__WOkyn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.ReceiptsPage_select__VcSXA {
  margin-left: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #cbd3e1;
  font-size: 13px;
  background: #fff;
}

/* бейдж района в таблице */
.ReceiptsPage_districtBadge__brf6L {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 999px;
  background: #e3f2fd;
  color: #1565c0;
  font-size: 11px;
  font-weight: 600;
}

/* бейдж района в карточке — крупнее */
.ReceiptsPage_districtBadgeBig__LQ6fo {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 999px;
  background: #e3f2fd;
  color: #1565c0;
  font-size: 12px;
  font-weight: 600;
}

/* === Пагинация === */
.ReceiptsPage_pagination__RTQmc {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  font-size: 13px;
}

.ReceiptsPage_pagination__RTQmc button {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #cbd3e1;
  background: #f9fafc;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s ease;
}

.ReceiptsPage_pagination__RTQmc button:hover:not(:disabled) {
  background: #e8eaf6;
}

.ReceiptsPage_pagination__RTQmc button:disabled {
  opacity: 0.4;
  cursor: default;
}

/* === Ошибка / пусто / загрузка === */
.ReceiptsPage_error__l4GI0 {
  margin: 8px 0;
  padding: 6px 10px;
  background: #ffebee;
  color: #c62828;
  border-radius: 4px;
  font-size: 13px;
}

.ReceiptsPage_noData__\\+fnp3,
.ReceiptsPage_loadingText__Yg-w6 {
  color: #444;
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/Receipts/ReceiptsPage.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* ReceiptsPage.module.css */\r\n\r\n/* === Общий контейнер === */\r\n.tableWrapper {\r\n  overflow-x: auto;\r\n  max-height: calc(100vh - 240px);\r\n  overflow-y: auto;\r\n  padding-right: 6px;\r\n}\r\n\r\n/* === Таблица === */\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n  font-size: 13px;\r\n}\r\n\r\n.table th {\r\n  background: #f5f6fa;\r\n  text-align: left;\r\n  padding: 8px 10px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.table td {\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  color: #444;\r\n}\r\n\r\n.table tr:hover {\r\n  background: #fafafa;\r\n}\r\n\r\n.right {\r\n  text-align: right;\r\n}\r\n\r\n/* === Блок товаров (единый стиль) === */\r\n.productsBlock {\r\n  margin-top: 6px;\r\n  padding-top: 4px;\r\n  border-top: 1px dashed #e0e0e0;\r\n  font-size: 12px;\r\n  color: #555;\r\n}\r\n\r\n.productItem {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  margin: 2px 0;\r\n}\r\n\r\n.productName {\r\n  flex: 1 1 auto;\r\n  font-weight: 500;\r\n}\r\n\r\n.productQty {\r\n  flex: 0 0 auto;\r\n  min-width: 60px;\r\n  text-align: right;\r\n}\r\n\r\n.productPrice {\r\n  flex: 0 0 auto;\r\n  min-width: 80px;\r\n  text-align: right;\r\n  opacity: 0.8;\r\n}\r\n\r\n.productSum {\r\n  flex: 0 0 auto;\r\n  min-width: 90px;\r\n  text-align: right;\r\n  font-weight: 600;\r\n}\r\n\r\n/* === Карточки === */\r\n.cardsWrapper {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\r\n  gap: 12px;\r\n  max-height: calc(100vh - 240px);\r\n  overflow-y: auto;\r\n  padding-right: 6px;\r\n}\r\n\r\n.receiptCard {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\r\n  padding: 12px 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.receiptCard:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.receiptHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  margin-bottom: 6px;\r\n  color: #333;\r\n}\r\n\r\n.receiptNumber {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: #3f51b5;\r\n}\r\n\r\n.receiptDate {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: #757575;\r\n  font-weight: 500;\r\n}\r\n\r\n.receiptBody {\r\n  font-size: 13px;\r\n  color: #444;\r\n  line-height: 1.4;\r\n  margin-top: 4px;\r\n}\r\n\r\n.receiptBody p {\r\n  margin: 2px 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.comment {\r\n  margin-top: 4px;\r\n  padding: 4px 6px;\r\n  background: #fff8e1;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n}\r\n\r\n/* === Переключатели вида === */\r\n.viewSwitch {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.switchBtn {\r\n  background: #f9fafc;\r\n  border: 1px solid #cbd3e1;\r\n  border-radius: 6px;\r\n  padding: 6px 10px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.switchBtn:hover {\r\n  background: #e8eaf6;\r\n}\r\n\r\n.switchBtn.active {\r\n  background: #3f51b5;\r\n  color: #fff;\r\n  border-color: #3f51b5;\r\n}\r\n\r\n/* === Панель с переключателем и районом === */\r\n.filtersRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.districtFilter {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n}\r\n\r\n.select {\r\n  margin-left: 4px;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  border: 1px solid #cbd3e1;\r\n  font-size: 13px;\r\n  background: #fff;\r\n}\r\n\r\n/* бейдж района в таблице */\r\n.districtBadge {\r\n  display: inline-block;\r\n  padding: 2px 6px;\r\n  border-radius: 999px;\r\n  background: #e3f2fd;\r\n  color: #1565c0;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* бейдж района в карточке — крупнее */\r\n.districtBadgeBig {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  border-radius: 999px;\r\n  background: #e3f2fd;\r\n  color: #1565c0;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* === Пагинация === */\r\n.pagination {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n  font-size: 13px;\r\n}\r\n\r\n.pagination button {\r\n  padding: 4px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid #cbd3e1;\r\n  background: #f9fafc;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.pagination button:hover:not(:disabled) {\r\n  background: #e8eaf6;\r\n}\r\n\r\n.pagination button:disabled {\r\n  opacity: 0.4;\r\n  cursor: default;\r\n}\r\n\r\n/* === Ошибка / пусто / загрузка === */\r\n.error {\r\n  margin: 8px 0;\r\n  padding: 6px 10px;\r\n  background: #ffebee;\r\n  color: #c62828;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n}\r\n\r\n.noData,\r\n.loadingText {\r\n  color: #444;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `ReceiptsPage_tableWrapper__ftYE-`,
	"table": `ReceiptsPage_table__TJ+eX`,
	"right": `ReceiptsPage_right__Fw4YC`,
	"productsBlock": `ReceiptsPage_productsBlock__jA0N5`,
	"productItem": `ReceiptsPage_productItem__IUd+A`,
	"productName": `ReceiptsPage_productName__qN8WM`,
	"productQty": `ReceiptsPage_productQty__P2xCp`,
	"productPrice": `ReceiptsPage_productPrice__drr72`,
	"productSum": `ReceiptsPage_productSum__wg6An`,
	"cardsWrapper": `ReceiptsPage_cardsWrapper__aB-i4`,
	"receiptCard": `ReceiptsPage_receiptCard__4Eu55`,
	"receiptHeader": `ReceiptsPage_receiptHeader__nRkNn`,
	"receiptNumber": `ReceiptsPage_receiptNumber__2ZG-J`,
	"receiptDate": `ReceiptsPage_receiptDate__1YtrN`,
	"receiptBody": `ReceiptsPage_receiptBody__j9YHO`,
	"comment": `ReceiptsPage_comment__3Jt4M`,
	"viewSwitch": `ReceiptsPage_viewSwitch__90GtE`,
	"switchBtn": `ReceiptsPage_switchBtn__w1WNf`,
	"active": `ReceiptsPage_active__2VMBD`,
	"filtersRow": `ReceiptsPage_filtersRow__nANre`,
	"districtFilter": `ReceiptsPage_districtFilter__WOkyn`,
	"select": `ReceiptsPage_select__VcSXA`,
	"districtBadge": `ReceiptsPage_districtBadge__brf6L`,
	"districtBadgeBig": `ReceiptsPage_districtBadgeBig__LQ6fo`,
	"pagination": `ReceiptsPage_pagination__RTQmc`,
	"error": `ReceiptsPage_error__l4GI0`,
	"noData": `ReceiptsPage_noData__+fnp3`,
	"loadingText": `ReceiptsPage_loadingText__Yg-w6`
};
export default ___CSS_LOADER_EXPORT___;
